<template>
  <div v-if="!isAuthenticated" id="Button-Handlers">
    <template v-if="status === 'available' && Userstatus !== 'ineligible'">
      <button
        v-b-modal.create-account
        v-if="Userstatus === 'lead'"
        :class="[courseStatus[status].button , classname]"
        @click="newEnrollmentStart(course_id,courseTitle,listing_id)"
      >{{courseStatus[status].display}}</button>
      <a
        href="javascript:void(0)"
        data-attribute="Button-Handlers"
        :data-title="courseTitle.toLowerCase()"
                  data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="main content"
                  :data-section="courseTitle.toLowerCase()"
                  data-text="resume course"
        v-else
        :class="[courseStatus[status].button , classname]"
        @click="enrollExistingUser(url , userFirstName , userEmail , courseTitle , course_id ,listing_id)"
      >{{courseStatus[status].display}}</a>
    </template>
    <a
      v-else-if="status ==='completed'"
      :href="url"
      :data-title="courseTitle.toLowerCase()"
      data-attribute="Button-Handlers"
      :class="[courseStatus[status].button , classname]"
    >{{courseStatus[status].display}}</a>
    <a
      :href="url"
      data-attribute="Button-Handlers"
      data-event="link"
          data-action="click"
          data-name="onclick"
          data-type="internal link"
          data-region="main content"
          :data-section="courseTitle.toLowerCase()"
          data-text="resume course"
      v-else-if="status === 'active'"
      :data-title="courseTitle.toLowerCase()"
      :class="[courseStatus[status].button , classname]"
    >{{courseStatus[status].display}}</a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { REGISTER_EXISTING } from "../../store/actions.type";
import { getEnvironment } from "../../common/env.util";
export default {
  data() {
    return {
      lmsUrl: ""
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  props: {
    courseStatus: Object,
    status: String,
    url: String,
    listing_id: String,
    Userstatus: String,
    course_id: String,
    userFirstName: String,
    userEmail: String,
    courseTitle: String,
    isAuthenticated: Boolean,
    classname: {
      type: String,
      default: ""
    }
  },
  methods: {
    enrollExistingUser(url, fullName, email, title, course_id,listing_id) {
      this.tealiumEventManagerStart(title,listing_id)
      this.tealiumEventManagerButtonClick(title,listing_id)
      this.$store
        .dispatch(REGISTER_EXISTING, {
          course_id: course_id
        })
        .then(response => {
          this.tealiumEventManagerEnd(title,listing_id, function(callback){
             window.location = response.courses[course_id].url;
          })
        })
        .catch(error => {
          this.tryingConnectCanvas = false;
          this.showDismissibleAlert = true;
          this.apiCall = error;
        });
    },
    newEnrollmentStart(course_id , courseTitle , listing_id){
      this.tealiumEventManagerStart(courseTitle,listing_id)
      this.tealiumEventManagerButtonClick(courseTitle,listing_id)
      this.$store.state.selectedCourse= course_id;
      this.$store.state.selectedCourseTitle= courseTitle;
      this.$store.state.listingId= listing_id
    },
    tealiumEventManagerEnd(title,listing_id,callback){
      utag.link({
            course_title: title,
            tealium_event: "enrollment_finished_event",
            customer_email: this.currentUser.user.email_address,
            customer_full_name: this.currentUser.user.first_name,
            listing_fee: "0.0",
        enrollment_fee: "0.0",
        order_total: "0.0",
            listing_id: listing_id,
            listing_url: window.location.href,
            timestamp: new Date()+""
          });
          callback()
    },
    tealiumEventManagerStart(title,listing_id){
      utag.link({
            course_title: title,
            tealium_event: "enrollment_start_event",
            customer_email: this.currentUser.user.email_address,
            customer_full_name: this.currentUser.user.first_name,
            listing_fee: "0.0",
        enrollment_fee: "0.0",
        order_total: "0.0",
            listing_id: listing_id,
            listing_url: window.location.href,
            timestamp: new Date()+""
          });
    },
    tealiumEventManagerButtonClick(title,listing_id){
      utag.link({
            course_title: title,
            tealium_event: "enrollment_button_click",
            customer_email: this.currentUser.user.email_address,
            customer_full_name: this.currentUser.user.first_name,
            listing_fee: "0.0",
        enrollment_fee: "0.0",
        order_total: "0.0",
            listing_id: listing_id,
            listing_url: window.location.href,
            timestamp: new Date()+""
          });
    }
  }
};
</script>

